import { CreateButton, List, useTranslate } from 'react-admin';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import { DashboardContent } from '../../../../../layouts/dashboard';
import ErrorPage403 from 'src/pages/error/403';
import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs/custom-breadcrumbs';
import { Resources } from '../../resource';
import { TurnkeyConfigForm } from './TurnkeyConfigForm';
import { ReactElement, useState } from 'react';

const View = () => {
  const translate = useTranslate();
  return (
    <PermissionGuard resource="turnkey-config" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent>
        <CustomBreadcrumbs heading={translate('resource.turnkeyConfig')} />
        <TurnkeyConfigForm></TurnkeyConfigForm>
      </DashboardContent>
    </PermissionGuard>
  );
};

export default View;
